module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "overflow": "hidden"
    }
  }, [_c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "90%",
      "border": "none"
    },
    attrs: {
      "src": "static/html/release-logs.2.5.5.html"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20d10c36!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/notice/seeLog.vue
// module id = 963
// module chunks = 2